import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["icon_name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getLocalTranslation } from '../../../utils/i18nKit';
import { PortalLoginSourceEnum } from './types';
export var JOVE_LOGO_URL = 'https://storage.googleapis.com/jove-email-templates/JoveLogo.png';
export var JOVE_PORTAL_BRAND = {
  name: 'Jove',
  logo: JOVE_LOGO_URL,
  primaryColor: '#12275B',
  accentColor: '#3B5BFF',
  surfaceColor: '#F4F7FF'
};
export var BROKER_FALLBACK_BRAND = {
  name: 'Broker Portal',
  primaryColor: '#12275B',
  accentColor: '#3B5BFF',
  surfaceColor: '#F4F7FF',
  partnerLabel: 'Powered by',
  joveLogo: JOVE_LOGO_URL
};
export var JOVE_FOOTER_INFO = {
  desc: 'Insurance products are arranged and underwritten via Jove, an MGA backed by Accelerant.',
  links: [],
  copyright: '© 2026 Jove. All rights reserved.'
};
export var resolvePortalLoginConfig = function resolvePortalLoginConfig(props) {
  var loginSource = props.loginSource,
      brand = props.brand,
      footerInfo = props.footerInfo;
  var isBroker = loginSource === PortalLoginSourceEnum.Broker;
  return {
    loginSource: loginSource || PortalLoginSourceEnum.Jove,
    brand: _objectSpread(_objectSpread({}, isBroker ? BROKER_FALLBACK_BRAND : JOVE_PORTAL_BRAND), brand),
    footerInfo: _objectSpread(_objectSpread({}, JOVE_FOOTER_INFO), footerInfo)
  };
};
export var getDefaultPortalLoginIntroInfo = function getDefaultPortalLoginIntroInfo() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    title: $t('text:login.intro.portal.title'),
    introList: [{
      iconName: 'Bolt',
      title: $t('text:login.intro.portal.quotes_title'),
      desc: $t('text:login.intro.portal.quotes_desc')
    }, {
      iconName: 'Description',
      title: $t('text:login.intro.portal.documents_title'),
      desc: $t('text:login.intro.portal.documents_desc')
    }, {
      iconName: 'WebAsset',
      title: $t('text:login.intro.portal.digital_title'),
      desc: $t('text:login.intro.portal.digital_desc')
    }]
  };
};
export var getDefaultDashboardLoginIntroInfo = function getDefaultDashboardLoginIntroInfo() {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  return {
    title: $t('text:login.intro.dashboard.title'),
    introList: [{
      iconName: 'Description',
      title: $t('text:login.intro.dashboard.policies_title'),
      desc: $t('text:login.intro.dashboard.policies_desc')
    }, {
      iconName: 'Bolt',
      title: $t('text:login.intro.dashboard.renew_title'),
      desc: $t('text:login.intro.dashboard.renew_desc')
    }, {
      iconName: 'Language',
      title: $t('text:login.intro.dashboard.community_title'),
      desc: $t('text:login.intro.dashboard.community_desc')
    }]
  };
}; // Organization validation portal login (loginSource=org) always shows the insurance validation copy

export var getDefaultOrgLoginIntroInfo = function getDefaultOrgLoginIntroInfo() {
  var _getLocalTranslation3 = getLocalTranslation(),
      $t = _getLocalTranslation3.$t;

  return {
    title: $t('text:login.intro.org.title'),
    introList: [{
      iconName: 'VerifiedUser',
      title: $t('text:login.intro.org.track_title'),
      desc: $t('text:login.intro.org.track_desc')
    }, {
      iconName: 'SupervisorAccountOutlined',
      title: $t('text:login.intro.org.workforce_title'),
      desc: $t('text:login.intro.org.workforce_desc')
    }, {
      iconName: 'AssignmentIndOutlined',
      title: $t('text:login.intro.org.invite_title'),
      desc: $t('text:login.intro.org.invite_desc')
    }]
  };
}; // Broker portals whose entity type is PartnerType.GENERAL (referral partner) fall back to this referral copy when no custom intro is configured

export var getDefaultPartnerLoginIntroInfo = function getDefaultPartnerLoginIntroInfo() {
  var _getLocalTranslation4 = getLocalTranslation(),
      $t = _getLocalTranslation4.$t;

  return {
    title: $t('text:login.intro.partner.title'),
    introList: [{
      iconName: 'Analytics',
      title: $t('text:login.intro.partner.referrals_title'),
      desc: $t('text:login.intro.partner.referrals_desc')
    }, {
      iconName: 'AssignmentIndOutlined',
      title: $t('text:login.intro.partner.invite_title'),
      desc: $t('text:login.intro.partner.invite_desc')
    }, {
      iconName: 'WebAsset',
      title: $t('text:login.intro.partner.branded_title'),
      desc: $t('text:login.intro.partner.branded_desc')
    }]
  };
}; // Jove's own portal login (loginSource=jove) always shows the company intro copy; broker portals use the shared default above or their CMS-configured intro

export var getDefaultJoveLoginIntroInfo = function getDefaultJoveLoginIntroInfo() {
  var _getLocalTranslation5 = getLocalTranslation(),
      $t = _getLocalTranslation5.$t;

  return {
    title: $t('text:login.intro.jove.title'),
    introList: [{
      iconName: 'Bolt',
      title: $t('text:login.intro.jove.instant_title'),
      desc: $t('text:login.intro.jove.instant_desc')
    }, {
      iconName: 'VerifiedUser',
      title: $t('text:login.intro.jove.capacity_title'),
      desc: $t('text:login.intro.jove.capacity_desc')
    }, {
      iconName: 'Analytics',
      title: $t('text:login.intro.jove.portal_title'),
      desc: $t('text:login.intro.jove.portal_desc')
    }]
  };
};
export var resolvePortalLoginIntroInfo = function resolvePortalLoginIntroInfo(settings, defaultInfo) {
  if ((settings === null || settings === void 0 ? void 0 : settings.login_intro_display_type) !== 'custom') {
    return defaultInfo || getDefaultPortalLoginIntroInfo();
  }

  var introList = (Array.isArray(settings === null || settings === void 0 ? void 0 : settings.login_intro_list) ? settings.login_intro_list : []).map(function (item) {
    var _ref = item !== null && item !== void 0 ? item : {},
        icon_name = _ref.icon_name,
        rest = _objectWithoutProperties(_ref, _excluded);

    return _objectSpread(_objectSpread({}, rest), {}, {
      iconName: icon_name || ''
    });
  });
  return {
    title: (settings === null || settings === void 0 ? void 0 : settings.login_intro_title) || '',
    introList: introList.length ? introList : []
  };
};